// Modules
import styled from 'styled-components'

export const ContainerGlobal = styled.div`
    overflow-y: auto;
`

export const Header = styled.div`
    border-bottom: 1px solid #e4e5e7;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 64px;

    .header__image {
        max-width: 91px;
        min-height: 24px;
        margin-left: 35px;
    }
`

export const Container = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: 100%;
`

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    max-width: 496px;
    margin-bottom: 24px;
    padding: 0 16px;

    & > h1 {
        text-align: center;
    }

    .title__medium {
        margin: 52px auto 26px auto;
        font-weight: 700;
        font-size: 32px;
        line-height: 32px;
    }

    .title__large {
        margin: 32px auto 16px auto;
        font-weight: 600;
        font-size: 44px;
        line-height: 56px;
    }
`

export const Illustration = styled.img`
    margin-top: 91px;
    max-width: 267px;
`
